module.exports = "<div>\n  <div style=\"display: block\">\n    <canvas #chartActions></canvas>\n  </div>\n</div>"